/* CONTROL DE VISUALIZACIÓN DE LISTA DE ELEMENTOS */

/**
 * Change the type to show the table of elements to grid or list
 *
 * @param      {string}  kindShow  The kind show
 */
window.changeShowTableElements = function (kindShow = "grid") {
    if (!kindShow) {
        kindShow = "grid";
    }
    setStorage("kindShow", kindShow);
    $(".changeGrid").removeClass('showOnGrid showOnList showOnTable').addClass(`showOn${ucfirst(kindShow)}`);
    $("#gridListButtons .gridAction").removeClass("active");
    $(`#gridListButtons .showOn${ucfirst(kindShow)}`).addClass("active");
};
